import { DeviceIcon, } from 'z3k-settings/components/service/components/device-io-model/ui/device-icon';
import { styled } from '@mui/material';
import { useCallback } from 'react';
export const DeviceModel = styled(DeviceIcon, {
    shouldForwardProp: (prop) => prop !== 'used_io_list',
})(({ used_io_list, theme, isActiveModbus }) => {
    const output_names = used_io_list.map((item) => item.io_name);
    const output_types = used_io_list.map((item) => item.obj_type);
    const used = { fill: theme.palette.warning.main };
    // const un_used = {fill: '#ff0000'};
    const un_used = {};
    const modbus_used = { fill: theme.palette.error.main };
    const hasNames = useCallback((...names) => names.some((name) => output_names.includes(name)), [output_names]);
    const hasType = useCallback((name) => output_types.includes(name), [output_types]);
    const relayStyle = useCallback((count) => ({
        [`.relay${count}_1`]: hasNames(`Реле №${count}`, `Реле №${count} - открытие`, `Реле №${count} - закрытие`)
            ? used
            : un_used,
        [`.relay${count}_2`]: hasNames(`Реле №${count}`, `Реле №${count} - открытие`, `Реле №${count} - закрытие`, `Реле №${count} - инверсия`)
            ? used
            : un_used,
        [`.relay${count}_3`]: hasNames(`Реле №${count} - инверсия`
        // 2024.09.09 Кириянов:
        // Обычно для работы смесителя питание от автомата подаём
        // на общий контакт реле открытия и реле закрытия.
        // Питание на открытие и закрытие смесителей берём с нормально разомкнутых контактов.
        // `Реле №${count} - закрытие`
        )
            ? used
            : un_used,
    }), [used, un_used, hasNames]);
    const outputStyle = useCallback((count) => ({
        [`.output${count}`]: hasNames(`Выход ОК №${count}`, `Выход ОК №${count} - открытие`, `Выход ОК №${count} - закрытие`, `Выход ОК №${count} - инверсия`, `Вход №${count}`, `Вход №${count} - открытие`, `Вход №${count} - закрытие`, `Вход №${count} - инверсия`, `Выход №${count}`, `Выход №${count} - открытие`, `Выход №${count} - закрытие`, `Выход №${count} - инверсия`, `Вх/Вых №${count}`, `Вх/Вых №${count} - открытие`, `Вх/Вых №${count} - закрытие`, `Вх/Вых №${count} - инверсия`)
            ? used
            : un_used,
    }), [used, un_used, hasNames]);
    const baStyle = useCallback((count) => ({
        [`.boiler${count}`]: hasNames(`АЦШ встроенный №${count}`, `АЦШ внешний №${count}`)
            ? used
            : un_used,
    }), [used, un_used, hasNames]);
    const ntcStyle = useCallback((count) => ({
        [`.ntc${count}`]: hasNames(`Вход NTC №${count}`) ? used : un_used,
    }), [used, un_used, hasNames]);
    const wireStyle = useCallback((count) => ({
        [`.wire${count}`]: hasType('wired_temperature_sensors') ? used : un_used,
    }), [used, un_used, hasType]);
    const analogStyle = useCallback((count) => ({
        [`.analog_out${count}`]: hasNames(`Аналоговый выход №${count}`)
            ? used
            : un_used,
    }), [used, un_used, hasNames]);
    const amperInStyle = useCallback((count) => ({
        [`.analog_inp${count}`]: hasNames(`Токовый вход №${count} (4-20 ma)`)
            ? used
            : un_used,
    }), [used, un_used, hasNames]);
    const elementStyles = useCallback((count, callback) => Array.from(Array(count).keys()).reduce((acc, cnt) => ({ ...acc, ...callback(cnt + 1) }), {}), []);
    const plug_show = { display: 'block !important' };
    const plug_hide = { display: 'none !important' };
    const plugStyle = useCallback((count) => ({
        [`#plug${count}`]: hasNames(`Реле №${count}`) ? plug_show : plug_hide,
    }), [plug_show, plug_hide, hasNames]);
    const modbusStyle = useCallback((count) => ({
        [`.modbus_${count}`]: isActiveModbus ? modbus_used : un_used,
    }), [isActiveModbus]);
    const result = {
        ...elementStyles(20, relayStyle),
        ...elementStyles(20, outputStyle),
        ...elementStyles(5, baStyle),
        ...elementStyles(10, ntcStyle),
        ...elementStyles(2, wireStyle),
        ...elementStyles(2, analogStyle),
        ...elementStyles(2, amperInStyle),
        ...elementStyles(3, plugStyle),
        ...elementStyles(2, modbusStyle),
    };
    return {
        // width: '100%',
        height: '100%',
        ...result,
    };
});
